/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { TextAlignLeftIcon16Light } from './TextAlignLeftIcon16Light';
import { TextAlignLeftIcon16Regular } from './TextAlignLeftIcon16Regular';
import { TextAlignLeftIcon16Solid } from './TextAlignLeftIcon16Solid';
import { TextAlignLeftIcon20Light } from './TextAlignLeftIcon20Light';
import { TextAlignLeftIcon20Regular } from './TextAlignLeftIcon20Regular';
import { TextAlignLeftIcon20Solid } from './TextAlignLeftIcon20Solid';
import { TextAlignLeftIcon24Regular } from './TextAlignLeftIcon24Regular';
import { TextAlignLeftIcon24Solid } from './TextAlignLeftIcon24Solid';
import { TextAlignLeftIcon32Regular } from './TextAlignLeftIcon32Regular';
import { TextAlignLeftIcon64Regular } from './TextAlignLeftIcon64Regular';
var sizes = {
    16: {
        light: TextAlignLeftIcon16Light,
        regular: TextAlignLeftIcon16Regular,
        solid: TextAlignLeftIcon16Solid,
    },
    20: {
        light: TextAlignLeftIcon20Light,
        regular: TextAlignLeftIcon20Regular,
        solid: TextAlignLeftIcon20Solid,
    },
    24: {
        regular: TextAlignLeftIcon24Regular,
        solid: TextAlignLeftIcon24Solid,
    },
    32: {
        regular: TextAlignLeftIcon32Regular,
    },
    64: {
        regular: TextAlignLeftIcon64Regular,
    },
};
export var TextAlignLeftIcon = forwardRef('TextAlignLeftIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
